import { Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { Lock } from "lucide-react";

/**
 * Blocks non-Pro users from every calculator route.
 * - Not signed in → opens Auth modal + redirects to /pricing
 * - Signed in without Pro/Team/Lifetime → redirects to /pricing
 * - Loading (user===null) → renders a lightweight placeholder to avoid flicker
 */
export default function ProtectedRoute({ children }) {
  const { user, isAuthed, hasPro, setShowAuth } = useAuth();
  const location = useLocation();

  // Fire the auth modal as a side-effect, not during render.
  useEffect(() => {
    if (user !== null && !isAuthed) {
      setShowAuth(true);
    }
  }, [user, isAuthed, setShowAuth]);

  // Still loading auth state
  if (user === null) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center">
        <div className="mono text-xs text-[#64748b] tracking-widest">CHECKING SUBSCRIPTION...</div>
      </div>
    );
  }

  if (!isAuthed) {
    return <Navigate to="/pricing" state={{ from: location.pathname, reason: "pro_required" }} replace />;
  }

  if (!hasPro) {
    return <Navigate to="/pricing" state={{ from: location.pathname, reason: "pro_required" }} replace />;
  }

  return children;
}

export function LockedPreview() {
  return (
    <div className="border border-[#334155] bg-[#11151c] p-8 text-center">
      <Lock className="w-8 h-8 text-[#f59e0b] mx-auto mb-3" />
      <p className="mono text-sm text-[#94a3b8]">Subscription required to access this calculator.</p>
    </div>
  );
}
